export const formatStringToKey = (str: string): string =>
    str
        .toLowerCase()
        .trim()
        .split(/(?:\s+|\_|\-|\,|\bor\b|\band\b)/g)
        .reduce((acc, word, index) => {
            if (acc === '') return word;
            else if (index === 0) return acc + word;
            else return acc + word.charAt(0).toUpperCase() + word.slice(1);
        }, '');
